export default "__VITE_ASSET__ac56d0de__"